import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { LhCoreModule } from './lh-core/lh-core.module';
import { AppRoutingModule } from './app-routing.module';
import {
    BrowserModule,
    provideClientHydration,
} from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
    HttpClientXsrfModule,
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { environment } from './environments/environment';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { HomeComponent } from './environments/home/home.component';
import { AccessDeniedComponent } from './environments/access-denied/access-denied.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';

const ngrxModules = [
    StoreModule.forRoot({}),
    EffectsModule.forRoot({}),
    StoreDevtoolsModule.instrument({
        trace: true,
        maxAge: 25,
        connectInZone: true,
    }),
];

@NgModule({
    declarations: [AppComponent, HomeComponent, AccessDeniedComponent],
    bootstrap: [AppComponent],
    imports: [
        ...ngrxModules,
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        LhCoreModule,
        HttpClientModule,
        HttpClientXsrfModule.withOptions({
            cookieName: 'XSRF-TOKEN',
            headerName: 'X-XSRF-TOKEN',
        }),
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        provideClientHydration(),
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class AppModule {}
